import { Id } from './common';

export enum ProviderAvailabilitySync {
  Disabled = 'disabled',
  SyncPractices = 'sync_practices',
  SyncPracticeGroups = 'sync_practice_groups',
}

export type Customer = {
  attributes: {
    created_at: string;
    id: Id;
    name: string;
    timezone: string;
    updated_at: string;
    supports_third_party_interpreters: boolean;
    supports_telephony_services: boolean;
    supports_patient_background_blur: boolean;
    supports_provider_background_blur: boolean;
    supports_patient_background_image: boolean;
    supports_provider_background_image: boolean;
    supports_visit_waiting_message_after_time_delay: boolean;
    visit_waiting_message_time_delay: number;
    use_default_phone_number: boolean;
    custom_phone_number: string | undefined;
    default_interpreter_phone: string | undefined;
    default_phone_number: string | undefined;
    available_locales: string[];
    provider_availability_sync: ProviderAvailabilitySync;
    total_active_practices: number;
  };
  id: Id;
  type: 'customer';
};

export type LanguageQuickSelect = {
  id: Id;
  language: string;
  position: number;
  audio_target?: string;
  has_audio_target?: boolean;
};

export type VideoBackground = {
  id: Id;
  kind: string;
  background_file_name: string;
  background_small: string;
  background_large: string;
};

export enum ManageViewsModes {
  Unpermitted = 'unpermitted',
  PersonalViews = 'personal_views',
  PersonalAndSharedViews = 'personal_and_shared_views',
}

export enum DefaultSegmentType {
  VisitSegment = 'visit_segment',
  LastVisited = 'last_visited',
}

export type ViewSettings = {
  id: number;
  customer_role_id: number;
  primary_view_id: number | null;
  manage_views_mode: ManageViewsModes;
  manage_columns_enabled: boolean;
  reorder_columns_enabled: boolean;
  filter_enabled: boolean;
  sort_enabled: boolean;
  created_at: string;
  updated_at: string;
};

export type CustomerRole = {
  id: number;
  customer_id: number;
  name: string;
  label: string;
  access_admin: boolean;
  access_app: boolean;
  access_patient_health_data: boolean;
  access_staff_visit_summaries: boolean;
  access_stats_dashboard: boolean;
  admin_payments: boolean;
  admin_reports: boolean;
  create_visits: boolean;
  create_staff_visits: boolean;
  licensed_provider: boolean;
  manage_admins: boolean;
  manage_payments: boolean;
  manage_practice_details: boolean;
  manage_staff_availability: boolean;
  manage_availability_toggling: boolean;
  manage_staff_visits: boolean;
  receive_staff_practice_notifications: boolean;
  run_reports: boolean;
  schedule_staff_visits: boolean;
  sign_staff_visit_notes: boolean;
  created_at: string;
  updated_at: string;
  user_count: number;
  view_settings?: ViewSettings;
};
